(function($, d, g) {
	'use strict';
	
	var recaptchaApiKey = '6LdaAn0UAAAAAIilSwqh3TJw8YSsHEdlIlStAYjV';
    var recaptchaInitLimit = 3000;
	
	var mailchimpOptions = {
		"baseUrl": "mc.us9.list-manage.com", 
		"uuid": "69c5444a4ab8780ae4e556425", 
		"lid": "99636fb7b3", 
		"uniqueMethods": true
	};
	
	// Object to export
	var utils = {
		/**
		 * RECAPTCHA UTIL FUNCTION Render recaptchas dynamically.
		 * 
		 * @param   btn		 An element referencing the button or a string 
		 *					  referencing the Id of the element.
		 * @param   callback	A function to be called after recaptcha has 
		 *					  completed its check. The function is passed back
		 *					  the recaptcha response and the form element.
		 * @param   validate	(optional) A boolean to know if a form needs to be 
		 *					  validated using the formValidator in com/form.js.
		 * @param   form		(optional) A jQuery object reference the form to be
		 *					  validated using formValidator in com/form.js.
		 */
		recaptcha: function (btn, callback, validate, form) {
            if (!btn || --recaptchaInitLimit <= 0) {
                return;
            }
            
			var it = this;
			if (!!g.grecaptcha) {
				if (grecaptcha.render) {
					grecaptcha.render(btn, {
						'sitekey': recaptchaApiKey,
						'callback': function (response) {
							var formValidator = Fw.component.models().form.validateForm;
							var validated = true;
							if (validate) {
								validated = false;
								formValidator(form);
								if (!form.hasClass('has-error')) {
									validated = true;
								}
							}

							if (validated) {
								callback(response, form);
							} else {
								grecaptcha.reset();
							}
						},
						'badge': 'inline'
					});
				} else {
					setTimeout(function () {
						it.recaptcha(btn, callback, validate, form);
					}, 250);
				}
			} else if (!g.grecaptcha) {
				setTimeout(function () {
					it.recaptcha(btn, callback, validate, form);
				}, 250);
			}
		},
        
		recaptcha2: function (btn, callback) {
            if (!btn || --recaptchaInitLimit <= 0) {
                return;
            }
            
			var it = this;
			if (!!g.grecaptcha && !!grecaptcha.render) {
                var div = $('<div class="recaptcha-ctn"></div>').insertBefore(btn);
                var widgetId = grecaptcha.render(div[0], {
                    'sitekey': recaptchaApiKey,
                    'callback': function (response) {
                        callback.call(btn, response);
                    },
                    'badge': 'inline',
                    'size': 'invisible'
                });
                btn.setAttribute('data-widget-id', widgetId);
                // Flow of register: stripe token -> recaptcha -> form validation -> submit
                if (!$(btn).hasClass('get-sripe-token')) {
                    $(btn).on('click', function() {
                        grecaptcha.execute(widgetId);
                    });
                }
			} else {
                setTimeout(function () {
                    it.recaptcha2(btn, callback);
                }, 250);
            }
		},
		
		sendEmail: function(email, subject, message, file, fields, callback) {
			var params = {
				email: email,
				subject: subject,
				file: file
			};
			if (message) {
				params.message = message;
			}
			for (var key in fields) {
				if (fields.hasOwnProperty(key) && /^field[123456]$/.test(key)) {
					params[key] = fields[key];
				}
			}
			$.ajax({
				url: "/action/sendEmail",
				method: "post",
				data: params,
				complete: function(response) {
					if (typeof callback === "function") callback(response.responseText);
				}
			});
		},
		
		getQuery: function(param, search) {
			var se = search !== undefined ? search : g.location.search;
			var qs = se.replace("?", "");
			if (!param || param === "") return qs;
			if (qs === "") return null;

			var qa = qs.split("&");
			for (var i = 0; i < qa.length; i++) {
				var q = qa[i];
				if (q.indexOf("=") > -1) {
					var a = q.split("=");
					if (a[0] === param) return a[1];
				} else {
					if (q === param) return "";
				}
			}
		},
		
		setQuery: function(param, value, search) {
			var se = search !== undefined ? search : g.location.search;
			var v = encodeURIComponent(value);
			if (se !== "") {
				var qa = se.replace("?", "").split("&");
				var qa2 = [];
				var isNew = true;

				for (var i = 0; i < qa.length; i++) {
					var qi = qa[i];
					var j = qi.indexOf("=");
					var qname = j > -1 ? qi.substring(0, j) : qi;
					if (qname === param) {
						if (v && v !== "") {
							qi = param + "=" + v;
						} else {
							qi = param;
						}
						isNew = false;
					}
					qa2.push(qi);
				}
				if (isNew) qa2.push(param + "=" + v);

				return qa2.join("&");
			} else if (v && v !== "") {
				return param + "=" + v;
			} else {
				return param;
			}
		},

		removeQuery: function(param, search) {
			var se = search !== undefined ? search : g.location.search;
			if (!param || param === "") return se.replace("?", "");

			var qa = se.replace("?", "").split("&");
			var qa2 = [];
			for (var i = 0; i < qa.length; i++) {
				var qi = qa[i];
				var j = qi.indexOf("=");
				var qname = j > -1 ? qi.substring(0, j) : qi;

				if (qname !== param) qa2.push(qi);
			}

			return qa2.join("&");
		},

		changeURLState: function(q, x, state, title) {
			var qs = "";
			var url = g.location.pathname;

			if (!q || typeof q !== "string") {
				return null;
			}

			if (x === null || x === undefined) {
				qs = this.removeQuery(q);
			} else {
				qs = this.setQuery(q, x);
			}
			if (qs !== "") {
				qs = "?" + qs;
			}
			url += qs + g.location.hash;

			return g.history.pushState(state, (title ? title : q + " " + x), url);
		},
		
		showMCPopup: function() {
			g.dojoRequire(["mojo/signup-forms/Loader"], function (L) { L.start(mailchimpOptions); });
			d.cookie = "MCPopupClosed=;expires=Thu, 01 Jan 1970 00:00:00 UTC";
		},
		
		animateCheck: function (response, container) {
			if (response.indexOf('success') !== -1) {
				container.find('.confirmation-check').addClass('run-animation');

				setTimeout(function () {
					container.find('.confirmation-check').removeClass('run-animation');
				}, 5000);
			}
		}
	};
	
	Fw.component.export('utils', utils);

})(jQuery, document, window);
